<script setup>
import { useI18n } from "vue-i18n";
import { computed } from "vue";

const { t } = useI18n();

const appCode = computed(() => import.meta.env.PUBLIC_APP_CODE ? import.meta.env.PUBLIC_APP_CODE : 'amablox')

</script>

<template>
    <span>
        {{ t(appCode) }}
    </span>
</template>
